//src\directives\draggable.js
// 拖拽指令
export const draggable = {
    bind(el) {
      // 获取弹窗头部元素
      const dialogHeaderEl = el.querySelector(".el-dialog__header");
      // 获取整个弹窗元素
      const dragDom = el.querySelector(".el-dialog");
   
      // 设置鼠标样式为移动
      dialogHeaderEl.style.cursor = "move";
   
      // 监听鼠标按下事件
      dialogHeaderEl.onmousedown = (e) => {
        // 计算鼠标相对弹窗头部的偏移量
        const disX = e.clientX - dialogHeaderEl.offsetLeft;
        const disY = e.clientY - dialogHeaderEl.offsetTop;
   
        // 获取可视区域的宽高
        const screenWidth = document.body.clientWidth;
        const screenHeight = document.body.clientHeight;
   
        // 获取弹窗的宽高
        const dragDomWidth = dragDom.offsetWidth;
        const dragDomHeight = dragDom.offsetHeight;
   
        // 计算可移动范围的边界值
        const minDragDomLeft = dragDom.offsetLeft;
        const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
   
        const minDragDomTop = dragDom.offsetTop;
        const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
   
        // 用于存储弹窗的位置信息
        let styL, styT;
   
        // 处理弹窗位置的百分比值转换为像素值
        if (window.getComputedStyle(dragDom).left.includes("%")) {
          styL =
            +document.body.clientWidth *
            (+window.getComputedStyle(dragDom).left.replace(/%/g, "") / 100);
          styT =
            +document.body.clientHeight *
            (+window.getComputedStyle(dragDom).top.replace(/%/g, "") / 100);
        } else {
          styL = +window.getComputedStyle(dragDom).left.replace(/px/g, "");
          styT = +window.getComputedStyle(dragDom).top.replace(/px/g, "");
        }
   
        // 监听鼠标移动事件
        document.onmousemove = function (e) {
          // 计算新的位置
          let left = e.clientX - disX;
          let top = e.clientY - disY;
   
          // 限制左右移动范围
          if (-left > minDragDomLeft) {
            left = -minDragDomLeft;
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft;
          }
   
          // 限制上下移动范围
          if (-top > minDragDomTop) {
            top = -minDragDomTop;
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop;
          }
   
          // 更新弹窗位置
          dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
        };
   
        // 监听鼠标松开事件
        document.onmouseup = function () {
          // 清除鼠标移动和松开事件的监听
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },
  }; 